<template>
  <div class="row" >
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'LeaveRequests')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('LeaveRequests')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-suitcase-rolling text-secondary fa-3x"></i>
            <div class="mt-2 formName">مرخصی</div>
          </template>
        </Card>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'OverTime')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('OverTime')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-user-clock text-secondary fa-3x"></i>
            <div class="mt-2 formName">اضافه کاری</div>
          </template>
        </Card>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'Mission')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('Mission')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-plane-alt text-secondary fa-3x"></i>
            <div class="mt-2 formName">ماموریت</div>
          </template>
        </Card>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'BuyRequest')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('BuyRequest')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-shopping-basket text-secondary fa-3x"></i>
            <div class="mt-2 formName">خرید</div>
          </template>
        </Card>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'CostPermission')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('CostPermission')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-money-check-edit-alt text-secondary fa-3x"></i>
            <div class="mt-2 formName">هزینه</div>
          </template>
        </Card>
      </div>
    </div>
    <div class="col-lg-2 col-md-3 col-sm-4 col-6 p-1" v-if="$session.get('Menu').filter((x) => x.RouteName == 'PaymentPermission')[0].isMojaz == 1">
      <div class="Pointer w-100" @click="Goto('PaymentPermission')">
        <Card class="text-center">
          <template v-slot:content>
            <i class="fad fa-coins text-secondary fa-3x"></i>
            <div class="mt-2 formName">مساعده</div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
  methods: {
    Goto(route) {
      this.$router.push({ name: route })
    },
    GetFormList() {
      var AxiosGet = { ArryfildValue: {}, Method: 'Get', Action: 'Cartabl/formList', Token: this.$session.get('Token') }
      this.$GetData_Body(AxiosGet).then((res) => {
        this.FormList = res
      })
    }
  },
  data(){
    return{
      style:'InLine',
      FormList:[]
    }
  },
  created(){
    this.GetFormList()
  }
}
</script>
<style scoped>
@keyframes shake {
  0% { transform: translateX(0); }
  35% { transform: translateX(-5px) rotate(-5deg); }
  65% { transform: translateX(5px) rotate(5deg); }
  100% { transform: translateX(0); }
}

#Card:hover i,#Card:hover .formName{
  transition: 0.5s;
  animation: shake 0.6s ;
  color:rgb(194, 140, 25) !important;
}

</style>
